// JQ4-45 · US-AUDIT-005 — Audit category constants (frontend)
//
// Maps the four API category buckets to their display labels.
// The underlying category enum values come from packages/shared.
// Spec refs: R-FILTER-01, R-FILTER-02, ADR-1.

import { useTranslation } from '@jq4race/i18n';
import type { AuditCategory } from '@jq4race/shared';

/** Catalog key for each category bucket shown in the filter bar. */
const CATEGORY_LABEL_KEYS: Record<AuditCategory, string> = {
  authentication: 'categories.authentication',
  ticket: 'categories.ticket',
  payment: 'categories.payment',
  configuration: 'categories.configuration',
};

/** All available category options, in display order, with translated labels. */
export function useCategoryOptions(): { value: AuditCategory; label: string }[] {
  const { t } = useTranslation('audit-log');
  return (['authentication', 'ticket', 'payment', 'configuration'] as const).map((value) => ({
    value,
    label: t(CATEGORY_LABEL_KEYS[value]),
  }));
}
